import { manageVerificationManualMethods } from './manage_verification_manual_methods';
import { manageVerificationManualRuntimeMethods } from './manage_verification_manual_runtime_methods';
import { manageVerificationResultMethods } from './manage_verification_result_methods';
import { manageVerificationSupportMethods } from './manage_verification_support_methods';

export const manageVerificationMethods = {
  ...manageVerificationSupportMethods,
  ...manageVerificationResultMethods,
  ...manageVerificationManualMethods,
  ...manageVerificationManualRuntimeMethods
};
